var map = {
	"./badgeCheck.svg": "0aa0",
	"./bolt.svg": "bd90",
	"./crown.svg": "7480",
	"./gift.svg": "02aa",
	"./medal.svg": "80f4",
	"./receiptStar.svg": "53a4",
	"./rocketLaunch.svg": "9fb8",
	"./trophyStar.svg": "5c96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3528";